import React, { HTMLAttributes, forwardRef } from 'react';
import clsx, { ClassValue } from 'clsx';

type BannerProps = HTMLAttributes<HTMLSpanElement> & {
  variant?: 'default' | 'warning' | 'success' | 'info' | 'danger';
  className?: ClassValue;
};

const Banner = forwardRef<HTMLSpanElement, BannerProps>(
  ({ variant = 'default', children, className, ...rest }, ref) => {
    const variantClasses = {
      default: 'bg-zinc-700 text-zinc-100 dark:bg-zinc-900 dark:text-zinc-100',
      warning:
        'bg-yellow-700 text-yellow-100 dark:bg-yellow-900 dark:text-yellow-100',
      success:
        'bg-green-700 text-green-100 dark:bg-green-900 dark:text-green-100',
      info: 'bg-blue-800 text-blue-100 dark:bg-blue-900 dark:text-blue-100',
      danger: 'bg-red-700 text-red-100 dark:bg-red-900 dark:text-red-100',
    };

    const baseClasses =
      'flex items-center gap-2 px-4 py-2 justify-center text-sm font-medium';

    const variantClass = variantClasses[variant] || variantClasses.default;

    const userClasses = clsx(className);

    return (
      <span
        className={`${baseClasses} ${variantClass} ${userClasses}`}
        ref={ref}
        {...rest}
      >
        {children}
      </span>
    );
  },
);
Banner.displayName = 'Banner';

export { Banner };
